import styled from 'vue-styled-components';

import { COLORS } from '@/styles/common.styled';

export const Wrapper = styled.div`
    display: block;

    & thead,
    tbody {
        display: inline-block;
    }
`;

export const ItemWrapper = styled.article`
    margin: 10px 0 0 28px;

    font-size: 13px;
    font-weight: 500;
    color: ${COLORS['gray-40']};
`;

export const Td = styled.div`
    width: 90%;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;
